export default function ViewNewsfeedModalCtrl(type, users, PersonaCollection) {
  'ngInject';

  const controller = this;
  controller.type = type;
  controller.users = users;
  controller.hasAccessToUser = PersonaCollection.hasAccessToUser;
}
